import {
    BrandStoreData,
} from "./SellerBrandTypes";

export const brandStores: Record<
    string,
    BrandStoreData
> = {
    salar: {
        slug: "salar",
        name: "SALAR",
        logo: "/assets/images/logos/salarlogo.png",
        heroImage:
            "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1800&q=94",
        heroEyebrow:
            "SALAR ORIGINALS",
        heroTitle:
            "Modern essentials, made to be lived in.",
        heroDescription:
            "Discover refined everyday clothing, expressive seasonal edits and versatile silhouettes built around comfort, confidence and repeat wear.",
        accentText:
            "Designed with purpose. Styled without effort.",
        followerText:
            "48.6K followers",
        verifiedText:
            "Verified Salar Brand",
        foundedText:
            "Curated since 2026",
        collections: [
            {
                id: "new-arrivals",
                title: "New Arrivals",
                subtitle:
                    "Fresh silhouettes and seasonal colours",
                image:
                    "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=900&q=92",
                route:
                    "/category/men-fashion",
            },
            {
                id: "shirts",
                title: "Signature Shirts",
                subtitle:
                    "Clean fits for work and weekends",
                image:
                    "https://images.unsplash.com/photo-1603252109303-2751441dd157?auto=format&fit=crop&w=900&q=92",
                route:
                    "/category/men-fashion/shirts",
            },
            {
                id: "weekend",
                title: "Weekend Edit",
                subtitle:
                    "Relaxed pieces with premium texture",
                image:
                    "https://images.unsplash.com/photo-1617137968427-85924c800a22?auto=format&fit=crop&w=900&q=92",
                route:
                    "/category/men-fashion/t-shirts",
            },
            {
                id: "essentials",
                title: "Everyday Essentials",
                subtitle:
                    "Easy layers you will keep reaching for",
                image:
                    "https://images.unsplash.com/photo-1516826957135-700dedea698c?auto=format&fit=crop&w=900&q=92",
                route:
                    "/category/men-fashion",
            },
        ],
        products: [
            {
                id: 1001,
                sourceId: 1,
                title: "Premium Solid Casual Shirt",
                description:
                    "Pure cotton regular-fit casual shirt crafted for everyday comfort and effortless premium styling.",
                image:
                    "/assets/images/products/men-fas/men-1.png",
                price: 1549,
                mrp: 2899,
                rating: 4.6,
                reviews: "18.4K",
                badge: "SALAR CHOICE",
                color: "Navy",
                category: "Shirts",
                tags: ["all", "bestseller", "deal"],
            },
            {
                id: 1002,
                sourceId: 2,
                title: "Minimal Printed Shirt",
                description:
                    "Contemporary printed shirt with breathable premium fabric and a clean modern silhouette.",
                image:
                    "/assets/images/products/men-fas/men-2.png",
                price: 1299,
                mrp: 1999,
                rating: 4.4,
                reviews: "12.8K",
                badge: "TRENDING",
                color: "Black",
                category: "Shirts",
                tags: ["all", "new", "deal"],
            },
            {
                id: 1003,
                sourceId: 3,
                title: "Checked Everyday Shirt",
                description:
                    "Classic checked cotton shirt with a relaxed fit designed for workdays and weekend styling.",
                image:
                    "/assets/images/products/men-fas/men-3.png",
                price: 1449,
                mrp: 2499,
                rating: 4.7,
                reviews: "45.5K",
                badge: "BEST SELLER",
                color: "Brown",
                category: "Shirts",
                tags: ["all", "bestseller"],
            },
            {
                id: 1004,
                sourceId: 4,
                title: "Resort Printed Shirt",
                description:
                    "Premium lightweight resort shirt with statement print, soft texture and relaxed summer styling.",
                image:
                    "/assets/images/products/men-fas/men-4.png",
                price: 1699,
                mrp: 2799,
                rating: 4.5,
                reviews: "22.1K",
                badge: "PREMIUM EDIT",
                color: "Blue",
                category: "Shirts",
                tags: ["all", "new"],
            },
            {
                id: 1005,
                sourceId: 5,
                title: "Textured Linen Shirt",
                description:
                    "Breathable linen-blend shirt with elevated texture, relaxed styling and premium detailing.",
                image:
                    "/assets/images/products/men-fas/men-5.png",
                price: 1849,
                mrp: 3199,
                rating: 4.6,
                reviews: "16.9K",
                badge: "LIMITED EDITION",
                color: "White",
                category: "Shirts",
                tags: ["all", "deal", "new"],
            },
            {
                id: 1006,
                sourceId: 6,
                title: "Premium Mandarin Shirt",
                description:
                    "Refined mandarin-collar shirt made with soft premium fabric for elevated smart casual occasions.",
                image:
                    "/assets/images/products/men-fas/men-6.png",
                price: 1749,
                mrp: 2999,
                rating: 4.8,
                reviews: "31.2K",
                badge: "SALAR EXCLUSIVE",
                color: "Green",
                category: "Shirts",
                tags: ["all", "bestseller"],
            },
            {
                id: 1007,
                sourceId: 1,
                title: "Essential Cotton Overshirt",
                description:
                    "Structured cotton overshirt with a relaxed profile, easy layering and understated utility details.",
                image:
                    "/assets/images/products/men-fas/men-1.png",
                price: 1899,
                mrp: 3299,
                rating: 4.5,
                reviews: "9.7K",
                badge: "NEW DROP",
                color: "Navy",
                category: "Layering",
                tags: ["all", "new"],
            },
            {
                id: 1008,
                sourceId: 2,
                title: "Contemporary Graphic Shirt",
                description:
                    "Soft-touch printed shirt with a confident graphic direction and lightweight all-day comfort.",
                image:
                    "/assets/images/products/men-fas/men-2.png",
                price: 1399,
                mrp: 2299,
                rating: 4.4,
                reviews: "11.2K",
                badge: "SPECIAL PRICE",
                color: "Black",
                category: "Shirts",
                tags: ["all", "deal"],
            },
            {
                id: 1009,
                sourceId: 3,
                title: "Classic Check Slim Shirt",
                description:
                    "A sharper take on everyday checks with a cleaner slim silhouette and soft woven cotton.",
                image:
                    "/assets/images/products/men-fas/men-3.png",
                price: 1599,
                mrp: 2699,
                rating: 4.7,
                reviews: "28.6K",
                badge: "CUSTOMER FAVOURITE",
                color: "Brown",
                category: "Shirts",
                tags: ["all", "bestseller"],
            },
            {
                id: 1010,
                sourceId: 4,
                title: "Vacation Print Relaxed Shirt",
                description:
                    "Fluid resort shirt designed for laid-back weekends, travel days and warm-weather dressing.",
                image:
                    "/assets/images/products/men-fas/men-4.png",
                price: 1499,
                mrp: 2599,
                rating: 4.5,
                reviews: "13.4K",
                badge: "WEEKEND EDIT",
                color: "Blue",
                category: "Resort",
                tags: ["all", "new", "deal"],
            },
            {
                id: 1011,
                sourceId: 5,
                title: "Linen Blend Summer Shirt",
                description:
                    "Airy linen blend with a refined hand feel, ideal for warm days and understated evening looks.",
                image:
                    "/assets/images/products/men-fas/men-5.png",
                price: 1999,
                mrp: 3499,
                rating: 4.6,
                reviews: "15.8K",
                badge: "PREMIUM FABRIC",
                color: "White",
                category: "Linen",
                tags: ["all", "new"],
            },
            {
                id: 1012,
                sourceId: 6,
                title: "Mandarin Collar Smart Shirt",
                description:
                    "Minimal collar design paired with soft premium fabric for a clean, modern smart-casual look.",
                image:
                    "/assets/images/products/men-fas/men-6.png",
                price: 1649,
                mrp: 2899,
                rating: 4.8,
                reviews: "24.9K",
                badge: "BEST SELLER",
                color: "Green",
                category: "Shirts",
                tags: ["all", "bestseller", "deal"],
            },
            {
                id: 1013,
                sourceId: 1,
                title: "Premium Everyday Navy Shirt",
                description:
                    "Versatile navy shirt with soft construction, clean seams and an easy regular silhouette.",
                image:
                    "/assets/images/products/men-fas/men-1.png",
                price: 1499,
                mrp: 2699,
                rating: 4.6,
                reviews: "20.1K",
                badge: "EVERYDAY ICON",
                color: "Navy",
                category: "Essentials",
                tags: ["all", "bestseller"],
            },
            {
                id: 1014,
                sourceId: 2,
                title: "Abstract Print Casual Shirt",
                description:
                    "Modern abstract print balanced with a wearable palette and breathable cotton-blend construction.",
                image:
                    "/assets/images/products/men-fas/men-2.png",
                price: 1199,
                mrp: 2199,
                rating: 4.3,
                reviews: "8.9K",
                badge: "DEAL PICK",
                color: "Black",
                category: "Printed",
                tags: ["all", "deal"],
            },
            {
                id: 1015,
                sourceId: 3,
                title: "Weekend Check Relaxed Shirt",
                description:
                    "Relaxed checked shirt made for casual layering with dependable comfort and easy styling.",
                image:
                    "/assets/images/products/men-fas/men-3.png",
                price: 1399,
                mrp: 2499,
                rating: 4.6,
                reviews: "17.3K",
                badge: "WEEKEND PICK",
                color: "Brown",
                category: "Checks",
                tags: ["all", "new"],
            },
            {
                id: 1016,
                sourceId: 4,
                title: "Statement Resort Shirt",
                description:
                    "A bolder print direction in a lightweight relaxed silhouette for summer and vacation dressing.",
                image:
                    "/assets/images/products/men-fas/men-4.png",
                price: 1599,
                mrp: 2899,
                rating: 4.5,
                reviews: "14.6K",
                badge: "TRENDING NOW",
                color: "Blue",
                category: "Resort",
                tags: ["all", "new", "deal"],
            },
            {
                id: 1017,
                sourceId: 5,
                title: "Textured Premium White Shirt",
                description:
                    "Clean white shirt elevated with subtle texture, soft drape and refined finishing details.",
                image:
                    "/assets/images/products/men-fas/men-5.png",
                price: 1799,
                mrp: 3099,
                rating: 4.7,
                reviews: "19.8K",
                badge: "SALAR EDIT",
                color: "White",
                category: "Premium",
                tags: ["all", "bestseller"],
            },
            {
                id: 1018,
                sourceId: 6,
                title: "Elevated Green Mandarin Shirt",
                description:
                    "A polished mandarin-collar shirt with rich colour, clean structure and soft premium comfort.",
                image:
                    "/assets/images/products/men-fas/men-6.png",
                price: 1699,
                mrp: 2999,
                rating: 4.8,
                reviews: "27.4K",
                badge: "SALAR EXCLUSIVE",
                color: "Green",
                category: "Premium",
                tags: ["all", "bestseller", "deal"],
            },
        ],
        storyCards: [
            {
                id: "origin",
                eyebrow: "THE SALAR STORY",
                title:
                    "A wardrobe built around real life.",
                description:
                    "SALAR began with a simple idea: everyday clothing should feel considered without becoming complicated. Our collections are designed around the moments that make up a normal week — commuting, meetings, coffee runs, travel, dinners and unplanned weekends.",
                secondaryDescription:
                    "Instead of chasing short-lived trends, we focus on proportion, comfort, useful colour and fabric feel. The result is a wardrobe that can be repeated, mixed and worn with confidence.",
                image:
                    "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&w=1400&q=94",
                stat: "01",
                statLabel: "Designed for repeat wear",
            },
            {
                id: "craft",
                eyebrow: "CRAFT & FABRIC",
                title:
                    "The difference is in what you notice after wearing it.",
                description:
                    "We pay attention to the details that shape the experience of a garment: how a collar sits, how a sleeve moves, how fabric breathes and how a shirt holds its shape after repeated wear.",
                secondaryDescription:
                    "Fabric selection, stitching, finishing and fit are treated as one system. Every collection is built to feel comfortable on the first wear and dependable after many more.",
                image:
                    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1400&q=94",
                stat: "02",
                statLabel: "Comfort-first construction",
            },
            {
                id: "design",
                eyebrow: "DESIGN PHILOSOPHY",
                title:
                    "Clean enough to combine. Distinct enough to remember.",
                description:
                    "Our design language is restrained but not anonymous. We use proportion, texture, subtle print, thoughtful colour and clean structure to create pieces that feel recognisable without being loud.",
                secondaryDescription:
                    "That balance makes SALAR easy to style across different settings, whether you are building a minimal wardrobe or mixing stronger seasonal pieces into your everyday rotation.",
                image:
                    "https://images.unsplash.com/photo-1523398002811-999ca8dec234?auto=format&fit=crop&w=1400&q=94",
                stat: "03",
                statLabel: "Versatility over excess",
            },
            {
                id: "future",
                eyebrow: "WHAT COMES NEXT",
                title:
                    "Growing a brand without losing the point.",
                description:
                    "As SALAR expands into new categories, the goal stays the same: make shopping simpler and make every product earn its place. We want each collection to feel connected, useful and easy to understand.",
                secondaryDescription:
                    "The future of the brand is broader, but not noisier — more categories, better materials, stronger fit systems and a cleaner experience from discovery to delivery.",
                image:
                    "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1400&q=94",
                stat: "04",
                statLabel: "Built to grow with purpose",
            },
        ],
    },
};

export const getBrandStore = (
    slug: string
) =>
    brandStores[
    slug
    ] ??
    brandStores.salar;
